import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'syn-searchbar-v2-filter-save-dialog',
    templateUrl: 'searchbar-v2-filter-save-dialog.component.html',
})
export class SearchbarFilterSaveDialogV2Component {
    constructor(
        public dialogRef: MatDialogRef<SearchbarFilterSaveDialogV2Component>,
        @Inject(MAT_DIALOG_DATA) public data,
    ) {
    }

    public cancel(): void {
        this.dialogRef.close();
    }
}
